import JobAddressCard from './JobAddressCard'
export default JobAddressCard
